import React from 'react';
import { PixelButton, PixelBox, PixelContainer } from './PixelComponents';

interface WelcomeModalProps {
  userNumber: string;
  loginCode: string;
  recoveryKeys: string[];
  onClose: () => void;
}

export const WelcomeModal: React.FC<WelcomeModalProps> = ({ userNumber, loginCode, recoveryKeys, onClose }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '10px',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '420px',
          maxHeight: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 'clamp(12px, 3vw, 24px)',
          padding: 'clamp(12px, 3vw, 20px)',
          borderRadius: '8px',
          userSelect: 'text',
          WebkitUserSelect: 'text',
          MozUserSelect: 'text',
          overflow: 'auto',
          boxSizing: 'border-box',
        }}
      >
        {/* Заголовок ANONIMAZER2000 с полосками */}
        <PixelContainer
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            paddingRight: 0,
            paddingLeft: 0,
            minHeight: 0,
          }}
        >
          <div style={{ flex: 1, height: '4px', backgroundColor: '#000', minWidth: '20px' }}></div>
          <div
            style={{
              padding: '0 clamp(8px, 2vw, 16px)',
              fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
              fontSize: 'clamp(14px, 4vw, 20px)',
              letterSpacing: '5%',
              userSelect: 'none',
              whiteSpace: 'nowrap',
            }}
          >
            ANONIMAZER2000
          </div>
          <div style={{ flex: 1, height: '4px', backgroundColor: '#000', minWidth: '20px' }}></div>

          {/* Белый контейнер с данными */}
          <div
            style={{
              backgroundColor: '#FFF',
              border: '3px solid #000',
              padding: 'clamp(16px, 4vw, 32px)',
              width: '100%',
              boxSizing: 'border-box',
            }}
          >
            {/* Номер пользователя */}
            <div style={{ marginBottom: 'clamp(12px, 3vw, 24px)' }}>
              <div
                style={{
                  fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                  fontSize: 'clamp(10px, 2.5vw, 12px)',
                  marginBottom: 'clamp(4px, 1vw, 8px)',
                  color: '#666',
                  userSelect: 'none',
                }}
              >
                ВОТ ТВОЙ НОМЕР
              </div>
              <div
                style={{
                  fontFamily: 'Roboto Mono, sans-serif',
                  fontSize: 'clamp(18px, 6vw, 32px)',
                  fontWeight: 'bold',
                  letterSpacing: 'clamp(2px, 0.5vw, 4px)',
                  userSelect: 'all',
                  cursor: 'text',
                  padding: '4px',
                  borderRadius: '4px',
                  transition: 'background-color 0.2s',
                  wordBreak: 'break-all',
                  lineHeight: '1.2',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#4f4f4f';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#000';
                }}
              >
                {userNumber}
              </div>
            </div>

            {/* Код для входа */}
            <div style={{ marginBottom: 'clamp(12px, 3vw, 24px)' }}>
              <div
                style={{
                  fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                  fontSize: 'clamp(10px, 2.5vw, 12px)',
                  marginBottom: 'clamp(4px, 1vw, 8px)',
                  color: '#666',
                  userSelect: 'none',
                }}
              >
                КОД ДЛЯ ВХОДА
              </div>
              <div
                style={{
                  fontFamily: 'Roboto Mono, sans-serif',
                  fontSize: 'clamp(18px, 6vw, 32px)',
                  fontWeight: 'bold',
                  letterSpacing: 'clamp(2px, 0.5vw, 4px)',
                  userSelect: 'all',
                  cursor: 'text',
                  padding: '4px',
                  borderRadius: '4px',
                  transition: 'background-color 0.2s',
                  wordBreak: 'break-all',
                  lineHeight: '1.2',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#4f4f4f';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#000';
                }}
              >
                {loginCode}
              </div>
            </div>

            {/* Ключи восстановления */}
            <div style={{ marginBottom: 'clamp(16px, 4vw, 32px)' }}>
              <div
                style={{
                  fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                  fontSize: 'clamp(10px, 2.5vw, 12px)',
                  marginBottom: 'clamp(4px, 1vw, 8px)',
                  color: '#666',
                  userSelect: 'none',
                }}
              >
                КЛЮЧ ВОССТАНОВЛЕНИЯ
              </div>
              <div
                style={{
                  fontFamily: 'Roboto Mono, sans-serif',
                  fontSize: 'clamp(12px, 3vw, 16px)',
                  lineHeight: '1.6',
                  textTransform: 'uppercase',
                  letterSpacing: 'clamp(1px, 0.2vw, 2px)',
                  fontWeight: 'bold',
                  userSelect: 'text',
                  cursor: 'text',
                  padding: 'clamp(6px, 2vw, 8px)',
                  backgroundColor: '#f9f9f9',
                  borderRadius: '4px',
                  border: '1px solid #e0e0e0',
                  wordWrap: 'break-word',
                  overflowWrap: 'break-word',
                }}
              >
                {recoveryKeys.map((word, i) => (
                  <span key={i}>
                    {word.toUpperCase()}
                    {i < recoveryKeys.length - 1 ? ' • ' : ''}
                  </span>
                ))}
              </div>
            </div>

            {/* Предупреждение */}
            <div
              style={{
                textAlign: 'center',
                fontSize: 'clamp(8px, 2vw, 10px)',
                fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                marginBottom: 'clamp(12px, 3vw, 24px)',
                color: '#666',
                userSelect: 'none',
                lineHeight: '1.4',
              }}
            >
              ЗАПИШИ, ЗАБУДЕШЬ - НАЧНЕШЬ ЗАНОВО
            </div>

            {/* Кнопка копирования всех данных */}
            <div
              style={{
                alignSelf: 'center',
                justifyItems: 'center',
                justifyContent: 'center',
                width: '100%',
                display: 'flex',
              }}
            >
              <PixelButton
                onClick={() => {
                  const textToCopy = `Номер: ${userNumber}\nКод: ${loginCode}\nКлючи: ${recoveryKeys.join(' ')}`;
                  navigator.clipboard.writeText(textToCopy);
                  alert('Данные скопированы в буфер обмена!');
                }}
                style={{
                  width: '100%',
                  padding: 'clamp(6px, 2vw, 8px)',
                  backgroundColor: '#f0f0f0',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontFamily: 'Tiny5, monospace',
                  fontSize: 'clamp(10px, 2.5vw, 12px)',
                  cursor: 'pointer',
                  minHeight: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                📋 СКОПИРОВАТЬ ВСЕ ДАННЫЕ
              </PixelButton>
            </div>
          </div>
        </PixelContainer>

        {/* Кнопка В ЧАТ! */}
        <div
          style={{
            display: 'flex',
            gap: '15px',
            height: 'clamp(44px, 12vw, 66px)',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <PixelButton
            backgroundColor='#C0C0C0'
            borderColor='#000000'
            shadowColor='#808080'
            onClick={onClose}
            size='large'
            style={{
              height: 'clamp(36px, 10vw, 54px)',
              width: '100%',
              maxWidth: '198px',
              minWidth: '120px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                fontSize: 'clamp(18px, 5vw, 30px)',
                letterSpacing: '5%',
              }}
            >
              В ЧАТ!
            </div>
          </PixelButton>
        </div>
      </div>
    </div>
  );
};
